import React, { useEffect, useState } from "react";
import { color } from "../../../StyleData/Config";
import {
  Grid,
  Typography,
  Paper,
  Select,
  MenuItem,
  TextField,
  Box,
  Button,
  Collapse,
  Divider,
  IconButton,
  Tab,
  FormControlLabel,
  Radio,
  Menu,
} from "@mui/material";
import { toast } from "react-toastify";
import UnifiedModal from "../../../Component/UnifiedModal";
import { Field, Form, Formik } from "formik";
import { axiosPrivate, siteInfo } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import {
  Add,
  ArrowBack,
  Circle,
  KeyboardArrowDown,
  KeyboardArrowUp,
  MoreHoriz,
  PlaylistAdd,
} from "@mui/icons-material";
import { fromUTC } from "../../../utils/dateUtil";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isSystemAccess } from "../../../ConfigInfo/Info";

const PMView = ({ direction, pmData, approvalContext }) => {
  const navigate = useNavigate();
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);
  const isSystem = isSystemAccess(siteInfoDetail);

  console.log(pmData, "checkPM");

  const [value, setValue] = useState("1");
  const [dotBL, setDotBL] = useState(null);
  const [remarkOpen, setRemarkOpen] = useState(true);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [approvalLevel, setApprovalLevel] = useState(null);
  const [rejectedDescription, setRejectedDescription] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectDescription, setRejectDescription] = useState("");

  const handleDot = (event) => {
    if (!dotBL) {
      setDotBL(event.currentTarget);
    } else {
      setDotBL(null);
    }
  };

  useEffect(() => {
    if (approvalContext?.approvalId) {
      fetchApprovalStatus();
    }
  }, [approvalContext]);

  const fetchApprovalStatus = async () => {
    if (!approvalContext?.approvalId) return;
    const link = masterAPI["workFlowApproval"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        const approvalRecord = res.data.result.find(
          (item) => item.id === approvalContext.approvalId,
        );
        if (approvalRecord) {
          setApprovalStatus(approvalRecord.status);
          setApprovalLevel(approvalRecord.workFlowLevel || null);
          setRejectedDescription(approvalRecord.description || "");
        }
      })
      .catch((e) => console.log(e, "fetch approval status error"));
  };

  const handleApprove = async () => {
    if (!approvalContext?.approvalId) return;
    const updateLink = masterAPI["workFlowApproval"].update;
    await axiosPrivate
      .put(`${updateLink}`, { id: approvalContext.approvalId, status: "Approved" })
      .then(() => {
        setApprovalStatus("Approved");
        // toast.success("Request approved successfully");
        setTimeout(() => navigate("/workflowapproval"), 1500);
      })
      .catch((e) =>
        // toast.error(e.response?.data?.failureMessage || "Failed to approve request"),
        console.log(e, "approve request error"),
      );
  };

  const handleReject = async () => {
    if (!approvalContext?.approvalId) return;
    if (!rejectDescription.trim()) {
      toast.error("Description is required to reject.");
      return;
    }
    const updateLink = masterAPI["workFlowApproval"].update;
    await axiosPrivate
      .put(`${updateLink}`, {
        id: approvalContext.approvalId,
        status: "Rejected",
        description: rejectDescription,
      })
      .then(() => {
        setApprovalStatus("Rejected");
        // toast.success("Request rejected successfully");
        setShowRejectModal(false);
        setRejectDescription("");
        setTimeout(() => navigate("/workflowapproval"), 1500);
      })
      .catch((e) =>
        // toast.error(e.response?.data?.failureMessage || "Failed to reject request"),
        console.log(e, "reject request error"),
      );
  };

  //     useEffect(()=>{
  //         const locationLink=masterAPI["location"].link
  //         axiosPrivate.get(`${locationLink}`).then(res=>{
  //             console.log(res.data.result)
  //             setLocationId(res.data.result)
  //         }).catch(e=>{
  //             console.log(e,"createpm locaion getall")
  //         })

  //         const assetLink=masterAPI["assets"].link
  //         axiosPrivate.get(`${assetLink}`).then(res=>{
  //             console.log(res.data.result)
  //             setAssetId(res.data.result)
  //         }).catch(e=>{
  //             console.log(e,"createpm asset getall")
  //         })

  //         const siteLink=masterAPI["site"].getall
  //         axiosPrivate.get(`${siteLink}`).then(res=>{
  //             console.log(res.data.result)
  //             setSiteId(res.data.result)
  //         }).catch(e=>{
  //             console.log(e,"createpm site getall")
  //         })

  //         const pmStatusLink=masterAPI["selectList"].pmStatus
  //         axiosPrivate.get(`${pmStatusLink}`).then(res=>{
  //             console.log(res.data)
  //             setPMStatus(res.data)
  //         }).catch(e=>{
  //             console.log(e,"getpmStatus Create pm")
  //         })

  //         const jobplanLink=masterAPI["jobPlan"].link
  //         axiosPrivate.get(`${jobplanLink}`).then(res=>{
  //           console.log(res.data.result)
  //           setJobPlan(res.data.result)
  //         }).catch(e=>{
  //           console.log(e,"getJobPlan Create pm")
  //         })

  //         const getjobType=masterAPI["selectList"].pmJobType
  //         axiosPrivate.get(`${getjobType}`).then(res=>{
  //     console.log(res.data)
  //           setJobType(res.data)
  //         }).catch(e=>{
  //           console.log(e,"jobtype Create pm")
  //         })

  //         const getFreqTime=masterAPI["selectList"].frequencyunitsfortime

  //         axiosPrivate.get(`${getFreqTime}`).then(res=>{
  //           console.log(res.data)
  //                 setFrequnittime(res.data)
  //               }).catch(e=>{
  //                 console.log(e,"freq unit time Create pm")
  //               })

  //               const getFreqMeter=masterAPI["selectList"].frequencyunitsformeter

  //         axiosPrivate.get(`${getFreqMeter}`).then(res=>{
  //           console.log(res.data)
  //                 setFrequnitmeter(res.data)
  //               }).catch(e=>{
  //                 console.log(e,"freq unit meter Create pm")
  //               })

  //               const meter=masterAPI["meter"].link

  //               axiosPrivate.get(`${meter}`).then(res=>{
  //                 console.log(res.data.result)
  //                       setMeter(res.data.result)
  //                     }).catch(e=>{
  //                       console.log(e," meter Create pm")
  //                     })

  // //////////////////priority////////////////////////////////////////
  // const priLink=masterAPI["assetPriority"].link
  // axiosPrivate.get(`${priLink}`).then(res=>{
  // console.log(res.data.result)
  //   setPriority(res.data.result)
  // }).catch(e=>{
  //   console.log(e,"failureClass Create Wo")
  // })

  //         },[])

  // const initialValue={
  //     description:"",
  //     name:"",
  //     locationId:"",
  //     assetId:"",
  //     status:"",
  //     priority:"",
  //     siteId:"",
  //     jobPlanId:"",
  //     workType:"",
  //     woCounter:"",
  //     pmMeterBasedScheduler: {
  //       continourTrigger:{
  //       meterId: "",
  //       frequency: 0,
  //       startAtValue: 0,
  //       earliestTriggerValue: 0,
  //       currentReading: 0,
  //       frequencyUnitForMeter: "",
  //       fixed:false,
  //       floating:false
  //       },
  //       gaugeTrigger:{
  //        meterId:"",
  //        when:""
  //       }
  //     },
  //     pmTimeBasedScheduler: {
  //       frequency: 0,
  //       frequencyUnitForTime: "",
  //       nextDueDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
  //       targetEndDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
  //       offsetDays: 0,
  //       fixed:false,
  //       floating:false
  //     }

  //    }

  const onSubmit = (values) => {
    console.log(values);
  };

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ p: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          width: "100%",
          mb: "1rem",
          gap: "1rem",
        }}
        // sx={{mb:"1rem"}}
      >
        <Link to="/pm">
          <IconButton>
            <ArrowBack />
          </IconButton>
        </Link>
        <Typography
          sx={{
            // color: color.masterDialogTitleColor,
            // fontSize: color.masterDialogFontSize,
            fontSize: color.AssetTitlesize,
            fontWeight: color.sideFontWeightAsset,
          }}
        >
          {pmData.code + " - " + pmData.name + " - " + pmData.workTypeName}
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            marginLeft: "auto",
          }}
        >
          <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
            <Circle sx={{ fontSize: "0.5rem", color: "green" }} />
            <Typography>{pmData.status}</Typography>
          </Box>
          {/* <MoreHoriz onClick={handleDot} sx={{ cursor: "pointer" }} />
              <Menu anchorEl={dotBL} open={Boolean(dotBL)} onClose={handleDot}>
                <MenuItem>Option 1</MenuItem>
                <MenuItem>Option 2</MenuItem>
                <MenuItem>Option 3</MenuItem>
              </Menu> */}
          <Box></Box>
        </Box>
      </Box>

      {(pmData.reasonToCancel || (approvalStatus === "Rejected" && rejectedDescription)) && (
        <Paper variant="outlined" sx={{ mb: 1, borderRadius: 1, overflow: "hidden" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 1.5,
              py: 0.75,
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
            }}
            onClick={() => setRemarkOpen((prev) => !prev)}
          >
            <Typography sx={{ fontSize: "13px", fontWeight: 600, color: color.masterPageTitleColor }}>
              Remark
            </Typography>
            <IconButton size="small" disableRipple>
              {remarkOpen ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
            </IconButton>
          </Box>
          <Collapse in={remarkOpen}>
            <Box
              sx={{
                px: 1.5,
                py: 1,
                borderTop: "1px solid #e0e0e0",
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
                backgroundColor: "#fff",
              }}
            >
              {(pmData.workFlowLevel || approvalLevel) && (
                <Typography sx={{ fontSize: "13px", color: "#1976d2", fontWeight: 500 }}>
                  Workflow Level: {pmData.workFlowLevel || approvalLevel}
                </Typography>
              )}
              <Typography sx={{ fontSize: "13px", color: "#d32f2f", fontWeight: 500 }}>
                Rejection Reason:
                <span style={{ fontWeight: 400, color: "#333", display: "block", wordBreak: "break-word", overflowWrap: "anywhere" }}>
                  {pmData.reasonToCancel || rejectedDescription}
                </span>
              </Typography>
            </Box>
          </Collapse>
        </Paper>
      )}

      <TabContext value={value}>
        <Box
          sx={{
            ".css-hg18dx-MuiButtonBase-root-MuiTab-root.Mui-selected": {
              color: color.TabLabelcolor,
              // p: 0.5,
            },
            display: "flex",
            justifyContent: "space-between",
            width: "98%",
          }}
        >
          <TabList
            onChange={handleChangeTab}
            aria-label="lab API tabs example"
            TabIndicatorProps={{
              sx: { backgroundColor: color.TabLabelcolor, height: "3px" },
            }}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="General" value="1" sx={{ textTransform: "none" }} />
            <Tab label="Scheduling" value="2" sx={{ textTransform: "none" }} />
          </TabList>

          {/* <IconButton type='submit' sx={{backgroundColor:color.TableButtonColor}}>
          <PlaylistAdd sx={{color:"white",fontSize:"1.7rem"}}/>
        </IconButton> */}
        </Box>
        <Box sx={{ mt: "1rem" }}>
          <TabPanel value="1" sx={{ p: 1 }}>
            {/* <CreateGeneral jobPlanIden={handleJobPlanId}/> */}
            <Grid
              container
              sx={{
                boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                p: 1.5,
                backgroundColor: "white",
              }}
            >
              <Grid item xs={12}>
                <Typography
                  sx={{
                    color: color.masterDialogTitleColor,
                    fontSize: color.masterDialogFontSize,
                    fontWeight: color.sideWeightFont,
                    mb: "10px",
                  }}
                >
                  Details
                </Typography>
                <Divider
                  sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                />
              </Grid>
              <Grid container item xs={12} spacing={"1rem"}>
                <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {pmData.name}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    PM Description
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {pmData.description}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Location
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {pmData.locationName}
                  </Typography>
                </Grid>
                {isSystem && (
                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      System
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.systemName || "--"}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Asset
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {pmData.assetName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Site
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {siteInfoDetail.siteName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    PM Status
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {pmData.status}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Job Type
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {pmData.workTypeCode + "-" + pmData.workTypeName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Job Priority
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {pmData.priority?.code +
                      " - " +
                      pmData.priority?.priorityName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Job Plan
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {pmData.jobPlanName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Job Responsible
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {pmData.workCenterName}
                  </Typography>
                </Grid>
                {/* <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    PM Counter
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {pmData.woCounter}
                  </Typography>
                </Grid> */}
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value="2" sx={{ p: 1 }}>
            {/* <CreateGeneral jobPlanIden={handleJobPlanId}/> */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Grid
                container
                sx={{
                  boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                  p: 1.5,
                  backgroundColor: "white",
                }}
                alignItems={"center"}
              >
                <Grid item xs={12} md={3} lg={2}>
                  <Typography
                    sx={{
                      color: color.masterDialogTitleColor,
                      fontSize: color.masterDialogFontSize,
                      fontWeight: color.sideWeightFont,
                      // mb: "10px",
                    }}
                  >
                    Schedule Type :
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                    }}
                  >
                    {pmData.scheduleType}
                  </Typography>
                  {/* <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="scheduleType"
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.scheduleType !== ""
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                          // onChange={(e) => {
                          //   console.log(e.target.value);
                          //   if (e.target.value === "Time") {
                          //     // setChecked({
                          //     //   time: true,
                          //     //   continuous: false,
                          //     //   gauge: false,
                          //     // });

                          //     setFieldValue("pmMeterBasedScheduler.meterId",null);
                          //     setFieldValue("pmMeterBasedScheduler.frequency",0);
                          //     setFieldValue("pmMeterBasedScheduler.startAtValue",0);
                          //     setFieldValue("pmMeterBasedScheduler.earliestTriggerValue",0);
                          //     setFieldValue( "pmMeterBasedScheduler.currentReading",0 );
                             
                          //     setFieldValue("pmMeterBasedScheduler.frequencyUnitForMeter",null  );
                                
                                
                            
                          //     setFieldValue("pmMeterBasedScheduler.triggertype","Continuous");
                                
                          
                        
                          //   } else if (e.target.value === "Meter") {
                          //     // setChecked({ ...checked, time: false });
                          //     setFieldValue("pmTimeBasedScheduler.frequency",0);
                          //     setFieldValue("pmTimeBasedScheduler.frequencyUnitForTime",null);
                          //     setFieldValue("pmTimeBasedScheduler.nextDueDate",moment().format("YYYY-MM-DDTHH:mm:ss"));
                          //     setFieldValue("pmTimeBasedScheduler.targetEndDate",moment().format("YYYY-MM-DDTHH:mm:ss"));
                          //     setFieldValue("pmTimeBasedScheduler.offsetDays",0);
                          //   }
                          //   setFieldValue("scheduleType", e.target.value);
                          // }}
                        >
                          {scheduleType.map((id, i) => (
                            <MenuItem key={i} value={id.value}>
                              {id.text}
                            </MenuItem>
                          ))}
                        </Field> */}
                </Grid>
              </Grid>
              <Grid
                container
                sx={{
                  boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                  p: 1.5,
                  backgroundColor: "white",
                }}
              >
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      color: color.masterDialogTitleColor,
                      fontSize: color.masterDialogFontSize,
                      fontWeight: color.sideWeightFont,
                      mb: "10px",
                    }}
                  >
                    Time Schedule Trigger
                  </Typography>
                  <Divider
                    sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                  />
                </Grid>
                <Grid container item xs={12} spacing={"1rem"}>
                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Frequency
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmTimeBasedScheduler?.frequency}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Frequency Unit
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmTimeBasedScheduler?.frequencyUnitForTime}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Work Duration
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmTimeBasedScheduler?.targetDay}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={direction === "column" ? 6 : 4}
                    sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                  >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Next Due Date
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmTimeBasedScheduler?.nextDueDate !== null &&
                      pmData.pmTimeBasedScheduler?.nextDueDate !== undefined
                        ? fromUTC(pmData.pmTimeBasedScheduler?.nextDueDate)
                            .tzString
                        : "---"}
                    </Typography>
                  </Grid>
                  {/* <Grid
                    item
                    xs={12}
                    md={direction === "column" ? 6 : 4}
                    sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                  >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Target End Date
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmTimeBasedScheduler?.targetEndDate !== null &&
                      pmData.pmTimeBasedScheduler?.targetEndDate !== undefined
                        ? fromUTC(pmData.pmTimeBasedScheduler?.targetEndDate)
                            .tzString
                        : "---"}
                    </Typography>
                  </Grid> */}

                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Offset Days
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmTimeBasedScheduler?.offsetDays}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={direction === "column" ? 6 : 4}
                    sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                  >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Time Base Schedule End By
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmTimeBasedScheduler?.timeBaseScheduleEndBy !==
                        null &&
                      pmData.pmTimeBasedScheduler?.timeBaseScheduleEndBy !==
                        undefined
                        ? fromUTC(
                            pmData.pmTimeBasedScheduler?.timeBaseScheduleEndBy,
                          ).tzString
                        : "---"}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    item
                    xs={12}
                    md={direction === "column" ? 6 : 4}
                    alignItems={"flex-end"}
                  >
                    <FormControlLabel
                      value="Fixed"
                      checked={pmData.pmType === "Fixed"}
                      control={<Radio />}
                      label="Fixed"
                    />
                    <FormControlLabel
                      value="Floating"
                      checked={pmData.pmType === "Floating"}
                      control={<Radio />}
                      label="Floating"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                sx={{
                  boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                  p: 1.5,
                  backgroundColor: "white",
                }}
              >
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      color: color.masterDialogTitleColor,
                      fontSize: color.masterDialogFontSize,
                      fontWeight: color.sideWeightFont,
                      mb: "10px",
                    }}
                  >
                    Continuous Trigger
                  </Typography>
                  <Divider
                    sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                  />
                </Grid>
                <Grid container item xs={12} spacing={"1rem"}>
                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Meter Id
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmMeterBasedScheduler?.meterName}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Frequency Unit
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmMeterBasedScheduler?.uomName}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Frequency
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmMeterBasedScheduler?.frequency}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      StartAt
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmMeterBasedScheduler?.startAtValue}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Earliest Trigger
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmMeterBasedScheduler?.earliestTriggerValue}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Meter Based Scheduler End By
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {
                        pmData.pmMeterBasedScheduler
                          ?.meterBaseScheduleEndByValue
                      }
                    </Typography>
                  </Grid>
                  {/* <Grid container item xs={12} md={direction==="column"?6:4} alignItems={"flex-end"} >
              
            <FormControlLabel value="Fixed" checked={pmData.pmType==="Fixed"} 
            control={<Radio 
           
            />} 
            label="Fixed" />
            <FormControlLabel value="Floating" checked={pmData.pmType==="Floating"} 
            control={<Radio 
             
               />} 
            label="Floating" />
           
            </Grid> */}
                </Grid>
              </Grid>
              {/* <Grid
                container
                sx={{
                  boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                  p: 1.5,
                  backgroundColor: "white",
                }}
              >
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      color: color.masterDialogTitleColor,
                      fontSize: color.masterDialogFontSize,
                      fontWeight: color.sideWeightFont,
                      mb: "10px",
                    }}
                  >
                    Gauge Trigger
                  </Typography>
                  <Divider
                    sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                  />
                </Grid>
                <Grid container item xs={12} spacing={"1rem"}>
                  <Grid item xs={12} md={direction === "column" ? 6 : 4}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Meter Id
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {pmData.pmMeterBasedScheduler?.gaugeTrigger?.meterName}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      When
                    </Typography>
                    <Box sx={{ display: "flex", gap: "1rem" }}>
                      <Typography
                        sx={{
                          fontSize: color.TabDatafontsize,
                          mb: color.TabDatamarginbottom,
                        }}
                      >
                        Gallons(g)
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: color.TabDatafontsize,
                          mb: color.TabDatamarginbottom,
                        }}
                      >
                        Reading less than
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: color.TabDatafontsize,
                          mb: color.TabDatamarginbottom,
                        }}
                      >
                        200
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid> */}
            </Box>
          </TabPanel>
        </Box>
      </TabContext>

      {approvalContext?.fromApproval && approvalStatus === "Pending" && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mr: 2, mt: 1, mb: 1 }}>
          <Button
            variant="contained"
            size="small"
            sx={{ textTransform: "none", backgroundColor: "green", "&:hover": { backgroundColor: "#388e3c" }, minWidth: 90 }}
            onClick={handleApprove}
          >
            Approve
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{ textTransform: "none", backgroundColor: "red", "&:hover": { backgroundColor: "#c62828" }, minWidth: 90 }}
            onClick={() => setShowRejectModal(true)}
          >
            Reject
          </Button>
        </Box>
      )}

      <UnifiedModal
        open={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        title="Reject Request"
        description="Please provide a reason for rejection:"
        inputLabel="Rejection Description"
        inputValue={rejectDescription}
        onInputChange={(e) => setRejectDescription(e.target.value)}
        onCancel={() => setShowRejectModal(false)}
        onReject={handleReject}
        rejectButtonColor="error"
        rejectButtonVariant="contained"
        minRows={2}
        autoFocus={true}
      />
    </Box>
  );
};

export default PMView;
